import React from 'react';
import { Helmet } from 'react-helmet-async';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import AboutUs from '../../../components/AboutUs/AboutUs';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const AboutUs1 = () => {
  const seo = {
    title: 'Adithya Infinity',
    description: 'Explore IT and Non-IT job opportunities, internships, career guidance, and build lasting collaborations with clients at V Adithya Infinity Pvt Ltd.',
    keywords: 'IT jobs, Non-IT jobs, internships, career guidance, client collaboration, career opportunities, V Adithya Infinity',
    canonical: `${process.env.REACT_APP_BASE_URL || 'https://www.adithyainfinity.com'}/about-us`,
    image: 'https://www.adithyainfinity.com/assets/images/career-guidance-banner.jpg',
  };

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonical} />

        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.canonical} />
        <meta property="og:image" content={seo.image} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta name="twitter:image" content={seo.image} />
      </Helmet>

      <div>
        <AboutUs />
        <MakeTheShift />
      </div>
    </>
  );
};

export default AboutUs1;
